/* eslint-disable no-useless-escape */
/* eslint-disable import/no-webpack-loader-syntax */

import React from "react";
import { Code } from "rebass";
import Heading from "../components/Heading";
import Exercise from "../components/Exercise";
import Theory from "../components/Theory";
import Tip from "../components/Tip";
import P from "../components/P";
import Command from "../components/Command";
import SH from "../components/SH";
import Toc from "../components/Toc";
import ButtonLink from "../components/ButtonLink";

const Page = () => (
  <div>
    <Toc active="fixtures" />
    <Heading fontSize={5}>Fixtures with Alice</Heading>
    <Theory>
      <P>Some words about Fixtures.</P>
    </Theory>
    <P>
      We would like to write now a Controller and a View to see the movies and
      actors we have in the database. But we have a problem, we don't have
      movies or actors in our database.
    </P>
    <P>
      It is very convenient to be able to generate some dummy data to populate
      the database at any time in our development (and testing) environments. We
      call these dummy data fixtures.
    </P>
    <P>Let's create some fixtures. Run this command:</P>
    <Command>composer require --dev hautelook/alice-bundle</Command>
    <Tip>
      <P>
        This recipe is in the <Code>contrib</Code> repository that is maintained
        by the community, so you must agree on use community maintained packages
        to install it.
      </P>
    </Tip>
    <P>
      Alice allows us to write our fixtures in a much more convenient way, and
      have access to a lot of generators of fake data.
    </P>
    <P>
      Let's try writing some fixtures. Open <Code>fixtures/movies.yml</Code>{" "}
      with your editor and write this:
    </P>
    <SH code={require("raw-loader!./code/fixtures-movie-1.txt")} />
    <P>
      Create the directory <Code>public/images</Code>. and run:
    </P>
    <Command>php bin/console hautelook:fixtures:load</Command>
    <P>
      Examine the table <Code>movies</Code>, and the contents of{" "}
      <Code>public/images</Code>.
    </P>
    <Exercise
      language="yaml"
      code={require("raw-loader!./code/fixtures-actor.txt")}
    >
      <P>Can you write fixtures for the Entity Actor?</P>
      <P>
        You can do it in the same file <Code>fixtures/movies.yml</Code>
      </P>
      <P>
        It should match the properties of our entity (name, picture). At this
        step, forget about the relationship with movies.
      </P>
      <P>
        Can you make images be about people instead of cats? Try a different
        category in http://lorempixel.com/
      </P>
    </Exercise>
    <P>What about the relationship between movies and actors?</P>
    <P>Just add a line to the movie fixtures:</P>
    <SH
      language="yaml"
      code={require("raw-loader!./code/fixtures-movie-2.txt")}
    />
    <P>And reload the fixtures:</P>
    <Command>php bin/console hautelook:fixtures:load</Command>
    <P>
      In our database the tables <Code>actor</Code> and <Code>movie_actor</Code>{" "}
      are now populated.
    </P>
    <ButtonLink to="/controllertemplate" title="Go to next section" />
  </div>
);

export default Page;



// WEBPACK FOOTER //
// ./src/pages/fixtures.js